// 盤面の幾何（mch-dice の hex.js を移植）。11行・奇数行7マス／偶数行6マス。セルは番号で呼ぶ。
// core の battle も同じ番号付けを使う前提（行0が上＝敵側）。
export const ROWS = 11;
const DIRS = [
  [1, 0],
  [1, -1],
  [0, -1],
  [-1, 0],
  [-1, 1],
  [0, 1],
] as const;

export const rowWidth = (row: number) => (row % 2 ? 7 : 6);
const axialQ = (col: number, row: number) => (row % 2 ? col - (row + 1) / 2 : col - row / 2);
/** 盤面左端からのx（ヘックス幅単位） */
export const cellX = (col: number, row: number) => col + (row % 2 ? 0 : 0.5);

export interface Cell {
  i: number;
  col: number;
  row: number;
  q: number;
  r: number;
  n: number[];
}

function build(): Cell[] {
  const cells: Cell[] = [];
  const byKey = new Map<string, number>();
  for (let row = 0; row < ROWS; row++) {
    for (let col = 0; col < rowWidth(row); col++) {
      const c: Cell = { i: cells.length, col, row, q: axialQ(col, row), r: row, n: [] };
      byKey.set(`${c.q},${c.r}`, c.i);
      cells.push(c);
    }
  }
  for (const c of cells) c.n = DIRS.map(([dq, dr]) => byKey.get(`${c.q + dq},${c.r + dr}`)).filter((v): v is number => v !== undefined);
  return cells;
}

export const CELLS = build();
export const CELL_COUNT = CELLS.length; // 71
export const cellAt = (col: number, row: number) => CELLS.find((c) => c.col === col && c.row === row)?.i;
export function dist(a: number, b: number) {
  const A = CELLS[a];
  const B = CELLS[b];
  const dq = A.q - B.q;
  const dr = A.r - B.r;
  return (Math.abs(dq) + Math.abs(dr) + Math.abs(dq + dr)) / 2;
}
export const neighbors = (i: number) => CELLS[i].n;
export const adjacent = (a: number, b: number) => CELLS[a].n.includes(b);
export const mirror = (col: number, row: number): [number, number] => [rowWidth(row) - 1 - col, ROWS - 1 - row];
